export const sharpPosition: {[props: string]: (number | null)[]} = {
    treble: [null, -4, -1, -5, -2, 1, -3, 0],
    bass: [null, -2, 1, -3, 0, 3, -1, 2],
    "treble-octave": [null, -4, -1, -5, -2, 1, -3, 0],
};
export const flatPosition: {[props: string]: (number | null)[]} = {
    treble: [null, 0, -3, 1, -2, 2, -1, 3],
    bass: [null, 2, -1, 3, 0, 4, 1, 5],
    "treble-octave": [null, 0, -3, 1, -2, 2, -1, 3],
};